<template>
  <div class="flex flex-col md:flex-row">
    <Navbar />
    <main
      class="flex-1 min-h-screen mt-16 md:mt-0 ml-0 pb-20 md:pb-32 sm:pb-14 transition-all"
      :class="main_class"
    >
      <div
        class="flex items-center justify-between relative pin-t md:pin-b pin-l w-full md:h-24 py-3 px-3 bg-grey-lighter overflow-hidden"
      >
        <div
          class="flex flex-start flex-wrap ml-5 items-center nav-profile-name px-2 py-2"
          v-if="currentUser.role == 'Investor'"
        >
          <span class="font-bold text-blue pb-1 text-xl uppercase">
            {{currentUser.name}}
          </span>
        </div>
        
        <progress-bar
          :progress="progress"
          v-if="progressBarActive && currentUser.role != 'Investor'"
        ></progress-bar>

        <div 
          v-if="currentUser.role == 'Investor'"
          class="flex justify-end items-center h-16 relative cursor-pointer"
        >
          <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Investor'">
            <sp-link
              :to="{
                name: 'InvestorFormPrincipal',
                params: {
                  ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id
                }
              }"
            >
              <a class="no-underline p-3 flex items-center">
                <img alt="profile" class="mr-4" src="../../assets/img/human-resources-search-men.svg" />
                <span class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm font-bold md:text-blue-darkest leading-loose transition-all"> 
                  {{ $t("nav.editer_profil") }}
                </span>
              </a>
            </sp-link>
          </div>
          
          <sp-link :to="{ name: 'logout' }" class="ml-5 no-underline cursor-pointer transition-all block py-3 md:py-3 align-middle md:whitespace-no-wrap border-b-4 md:border-b-0 transition-opacity hover:opacity-100 min-h-sm">
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-2 text-grey text-xl sp-icon-logout-2"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm font-bold md:text-blue-darkest leading-loose transition-all"
            >{{ $t("nav.logout") }}</span>
          </sp-link>
        </div>
      </div>
      <div class="main-content py-3 px-3 md:p-8">
        <slot />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import progressBar from "@/components/Candidat/progressBar.vue";
import { mapGetters } from "vuex";
import Link from "@/components/spKit/Link.vue";
import { FETCH_ECOSYSTEM_APPLICATION, LOGOUT } from "@/store/actions.type";

export default {
  name: "default",
  data() {
    return {
      progress: 10,
      main_class: "md:ml-60",
      progressBarActive: true,
      routerNoprogressBar: ["home"],
      ecoAppId: null,
    };
  },
  components: {
    Navbar,
    "sp-link": Link,
    Footer,
    "progress-bar": progressBar
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: "home" });
      });
    },
  },
  watch: {
    barActive() {
      if (this.barActive == 1) this.main_class = "md:ml-22";
      else this.main_class = "md:ml-60";
    },
    $route() {
      this.progressBarActive = !this.routerNoprogressBar.includes(
        this.$route.name
      );
    }
  },
  computed: {
    ...mapGetters(["barActive", "ecosystemApp", "currentUser"])
  },
  mounted() {
    this.progressBarActive = !this.routerNoprogressBar.includes(
      this.$route.name
    );
    if (this.sidebarActive == 1) this.main_class = "md:ml-22";
    else this.main_class = "md:ml-60";
  }
};
</script>

<style>
  .nav-profile-name {
    background: lightgrey;
  }
  .nav-profile-name span:before {
    /* content: "\f007"; */
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    margin-right: 0.5rem;
  }

  .nav-profile-name span:hover {
    text-decoration: none;
    color: #333;
  }

  .flex-end {
        justify-content: end;
  }

  .flex-start {
    justify-content: start;
  }

</style>
